import React from 'react';
import AnimatedCounter from '../AnimatedCounter/AnimatedCounter';
import styles from './HeroSection.module.css';

const HeroSection = () => {
  const scrollToContent = () => {
    const nextSection = document.querySelector('#adoption-section');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className={styles.hero} aria-label="Hero section">
      <h1 className={styles.title}>
        The Ohio State App 2025
      </h1>
      
      <div className={styles.content}>
        <p className={styles.subtitle}>
          Empowering Buckeyes With A Seamless Campus Experience
        </p>
        
        <div className={styles.mission}>
          <p className={styles.missionText}>
            Our goal is simple: Make students' lives easier. The Ohio State App brings together everything 
            Buckeyes need in one place, creating a personalized campus experience for every step of their journey.
          </p>
        </div>
        
        <h2 className={styles.statsTitle}>Over The Past Year</h2>
        
        <div className={styles.stats}>
          <div className={styles.stat}>
            <span className={styles.statNumber}>
              <AnimatedCounter end={213009} />
            </span>
            <span className={styles.statLabel}>Unique Users</span>
          </div>
          
          <div className={styles.stat}>
            <span className={styles.statNumber}>
              <AnimatedCounter end={89243214} />
            </span>
            <span className={styles.statLabel}>Screen Views</span>
          </div>
          
          <div className={styles.stat}>
            <span className={styles.statNumber}>
              <AnimatedCounter end={713324} />
            </span>
            <span className={styles.statLabel}>Article Views</span>
          </div>
        </div>
      </div>
      
      <button 
        className={styles.scrollIndicator}
        onClick={scrollToContent}
        aria-label="Scroll to content"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
        </svg>
      </button>
    </section>
  );
};

export default HeroSection;
